import { useGlobal } from '../hooks/useGlobal';
import styled, { keyframes } from 'styled-components6';

export const GlobalLoader = () => {
    const { isReady } = useGlobal();

    return (
        <StyledGlobalLoader id="rwl-global-loader" $visible={!isReady}>
            <svg
                width="135"
                height="75"
                viewBox="0 0 135 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M73.003 74.9999H61.0005L67.0018 64.5779L73.003 74.9999Z"
                    fill="white"
                />
                <path
                    d="M134.004 0L119.08 25.9393L104.16 51.8726L90.8528 75L75.9326 49.0578L89.2371 25.9393L104.16 0H134.004Z"
                    fill="white"
                />
                <path
                    d="M86.2987 0L80.3063 10.422L67.0018 33.5465L53.6944 10.422L44.7665 25.9393L58.071 49.0578L43.1479 75L29.8434 51.8726L14.9202 25.9393L0 0H86.2987Z"
                    fill="white"
                />
            </svg>
        </StyledGlobalLoader>
    );
};

const scrollingGradient = keyframes` 
    0%   { background-position: 0 0; }
    100% { background-position: -200% 0; }
`;

const StyledGlobalLoader = styled.div<{ $visible?: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    pointer-events: none;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;
    cursor: default;
    background: repeating-linear-gradient(
        to right,
        var(--rwl-palette-gray-100) 0%,
        var(--rwl-palette-gray-100) 25%,
        var(--rwl-palette-gray-300) 50%,
        var(--rwl-palette-gray-100) 75%,
        var(--rwl-palette-gray-100) 100%
    );
    background-size: 200% auto;
    background-position: 0 100%;
    animation: ${scrollingGradient} 5s infinite;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
`;
